// @flow

import {createIdentity, createIdentities} from "./createIdentities";

export const identity = {
  createIdentities,
  createIdentity,
};
